import { IAccountManager } from './accountmanager';
import { ICardAdmin } from './cardadmin';

export interface IAccount {
  id: string;
  name: string;
  contact: string;
  ledger: string;
  ledgerNumber: string;
  product: string;
  office: string;
  accountManager: IAccountManager;
  cardAdmin: ICardAdmin;
  accountHasCO2CountEnabled: boolean;
  selected: boolean;
}

export class AccountAccessModel {
  EndPointURL: string;
  Token: string;
  UserId: string;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/accounts/account.ts